module.exports = __webpack_public_path__ + "static/media/cz_karta klienta_KSK_tekst7.3963d99f.webp";